import {
  upsertContent, getContent, createContent
}
from '@/models/freedomain';

import {
  nFormatter,
  createSeries,
  createSQL,
  seriesHead,
  appendAggregateValues,
  seriesDataItem,
  pickItem,
  isDateTransformation,
  highestModel,
  averageModel,
  missingValuesModel,
  resolve,
  getSeriesColors,
  extractColors
} from "@/components/charts/common";


const formColumns = ["id", "name", "description", "type", "foreign_id", "status", "open_id", "open_code"];
const stepperColumns = ["type", "foreign_id", "status"];
class Fn {
  setGlobalValues(stepper, chart) {
    this.stepper = stepper;
    this.chart = chart;



    this.setDomainValues(this.stepper.stepIndex);


    for(let i = 0; i < stepper.steps.length; i++) {
      try {
        this.setStepGlobalValues(stepper.steps[i]);
      } catch(err) {
        console.log("err", err);
      }
    }

    console.log("chart", chart);
    console.log("stepper", stepper);

  }
  setDomainValues(index) {
    if(typeof this.chart == "undefined" || typeof this.chart.domain == "undefined") {
      return false;
    }
    let step = this.stepper.steps[index];
    // this.setValue(this.chart.domain, this.stepper, "name");
    this.setValue(this.chart.domain, this.stepper, "type");
    this.setValue(this.chart.domain, step, "status");

    // if(typeof step.name != "undefined")
  }
  setValue(data1, data2, key) {
    if(typeof data2[key] != "undefined") {
      data1[key] = data2[key];
    }

  }
  setStepGlobalValues(step) {
    try {
      for(let i = 0; i < step.details.rows.length; i++) {
        if(typeof step.details.rows[i].multiple != "undefined" && step.details.rows[i].multiple) {

          this.setRowGlobalValues(step.details.rows[i], step.id, i);
        } else {
          this.setRowGlobalValues(step.details.rows[i], step.id);
        }

      }
    } catch(err) {

    }
  }
  setRowGlobalValues(row, id, rowIndex) {
    for(let i = 0; i < row.elements.length; i++) {
      this.setElementGlobalValues(row.elements[i], id, row, rowIndex, );
    }
  }
  setElementGlobalValues(element, id, row, rowIndex) {
    try {
      if(typeof this.stepper.values == "undefined") {
        this.stepper.values = {};
      }
      if(typeof element.name != "undefined") {
        // if(element.name )
        const key = id + "_" + element.name;

        if(typeof rowIndex != "undefined") {
          if(typeof this.stepper.values[id] == "undefined") {
            this.stepper.values[id] = [];
          }
          if(typeof this.stepper.values[id][rowIndex]  == "undefined") {
            this.stepper.values[id][rowIndex] = {};
          }
          this.stepper.values[id][rowIndex][element.name] = element.model;
          // if(typeof this.stepper.values[key])
        } else {
          this.stepper.values[key] = element.model;
        }
        // if(typeof this.stepper.values[key] != "undefined") {
        //
        // }

      }

      if(formColumns.includes(element.name)) {
        row[element.name] = element.model;
      }

      if(typeof element.globalName != "undefined") {
        if(formColumns.includes(element.globalName)) {
          this.chart.domain[element.globalName] = element.model;
        }
      }

    } catch(err) {
      console.log("element error", err);
    }
  }
};

const fn = new Fn();

async function prepare(domain, chart, data) {

  domain.hydrateContentToObject();

  try {
    domain.content.tableName = data.tableName;
    if(typeof domain.content.stepIndex == "undefined") {
      domain.content.stepIndex = 0;
    }
  } catch(err) {
    console.log("err", err);
    console.log("domain err", domain);

  }
  console.log("domain", domain);
  chart.domain = domain;
}


function loadData(domain, chart, data) {
  let content = data.template;
  let values = content.values;
  for(let i = 0; i < content.steps.length; i++) {
    let step = content.steps[i];
    for(let j = 0; j < step.details.rows; j++) {
      let row = step.details[j];
      loadRowValues(row, values, step.id);
    }
  }
}

function loadRowValues(row, values, id) {

}

export default async function hydrator(parameters, data, chart) {


  chart.fn = fn;
  data.template = resolve("template.value", parameters);
  data.tableName = resolve("tableName.value", parameters);

  let parameterisedFilterObject = resolve("tree.parameterisedFilterObject", chart, {});
  // parameterisedFilterObject._id = 1;

  let domain = createContent();
  data.template = JSON.parse(JSON.stringify(data.template));
  domain.content = JSON.parse(JSON.stringify(data.template));

  if(typeof parameterisedFilterObject._id != "undefined" && parameterisedFilterObject._id) {
    //console.log("get domain");
    domain = await getContent(data.tableName, parameterisedFilterObject._id);
    //console.log(domain);
  } else {
    // domain = await upsertContent(data.tableName, domain);
  }

  prepare(domain, chart, data);

  chart.save = async function(stepper) {
    console.log("saved 1", chart.domain);
    if(typeof stepper != "undefined") {
      chart.domain.content = stepper;
    }
    domain = await upsertContent(data.tableName, chart.domain);
    console.log("saved 2", chart.domain);
    prepare(domain, chart, data);
    return chart.domain;
  };

  if(typeof chart.$el != "undefined") {
    chart.$el.updateValues();
  }

}
